module.exports = __webpack_public_path__ + "static/media/index_05.0dbf8543.png";